<template>
  <move-template :order-type="queryParam.value.business.orderType" :type="type"/>
</template>

<script>
import MoveTemplate from '@/views/operation/movebound/MoveTemplate.vue'

export default {
  name: 'LocationMoveOrder',
  components: { MoveTemplate },
  props: {
    queryParam: { type: Object, default: null }
  },
  data() {
    return {
      type: 'adjustmentTransfer'
    }
  },
  methods: {}
}
</script>